import isEqual from "lodash/isEqual";
import { type EffectCallback, useEffect, useRef } from "react";

export function useDeepCompareEffect(
	callback: EffectCallback,
	dependencies: unknown[],
	useEffectHook = useEffect,
) {
	const previousDepsRef = useRef<unknown[]>([]);

	if (!isEqual(previousDepsRef.current, dependencies)) {
		previousDepsRef.current = dependencies;
	}

	useEffectHook(callback, [previousDepsRef.current]);
}
